// extracted by mini-css-extract-plugin
module.exports = {"email":"ChangeEmailStaffScreen_email__teUzw","footer":"ChangeEmailStaffScreen_footer__1kTce"};